import React from 'react';
import { InverntoryStatusLabel } from '../MenuProvider';

export default ({ data: { inventory } }) => (
  <>
    <div style={{ alignItems: 'flex-start' }}>
      <InverntoryStatusLabel status={inventory} />
    </div>
    <div>本商品目前已完售，歡迎選擇其他日期之菜單，提前預訂商品。</div>
  </>
);
